import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Line, { x1: "2", x2: "22", y1: "2", y2: "22", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12 12H2v4h14", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M22 12v4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M18 12h-.5", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M7 12v4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M18 8c0-2.5-2-2.5-2-5", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M22 8c0-2.5-2-2.5-2-5", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "CigaretteOff";
const CigaretteOff = memo(themed(Icon));
export {
  CigaretteOff
};
//# sourceMappingURL=cigarette-off.js.map
